import React, { useContext } from "react";

import { WalletItem } from "@components-shared/desktop/inputs/WalletItem";
import { DepositContext } from "@state/context/payment/DepositContext";
import { THEME_SETTINGS } from "@theme-settings";
import { observer } from "mobx-react-lite";

export default observer(function DepositWalletSelector() {
	const {
		onlineWallet,
		casinoWallet,
		liveCasinoWallet,
		gamesWallet,
		shouldShowWalletSelectors,
	} = useContext(DepositContext);
	return (
		<ul className="wallet">
			<WalletItem
				wallet={onlineWallet}
				isList={true}
				hidden={!shouldShowWalletSelectors}
			/>
			{WEBPACK_IS_CASINO_ENABLED ? (
				<WalletItem
					wallet={casinoWallet}
					isList={true}
					hidden={!shouldShowWalletSelectors}
				/>
			) : null}
			{WEBPACK_IS_CASINO_LIVE_ENABLED &&
			THEME_SETTINGS.showLiveCasinoWalletPayment ? (
				<WalletItem
					wallet={liveCasinoWallet}
					isList={true}
					hidden={!shouldShowWalletSelectors}
				/>
			) : null}
			<WalletItem
				wallet={gamesWallet}
				isList={true}
				hidden={!shouldShowWalletSelectors}
			/>
		</ul>
	);
});
